import { features } from '@/mocks/data';

export default function FeaturesSection() {
  return (
    <section className="py-20 md:py-28">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-sm text-primary-500 font-medium mb-3 tracking-wide">平台功能</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            全方位的数字体验工具
          </h2>
          <p className="text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
            17c提供六大核心功能模块，覆盖内容管理、数据分析到团队协作的全链路需求。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}